/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Ograniczone adaptery nowych widoków. Obliczenia pozostają w PHP; magazyny
   obserwowanych i szkicu pozostają jedynymi źródłami lokalnych wyborów. */
(function (root, doc) {
    'use strict';
    var en = /^en(?:-|$)/i.test(doc.documentElement.lang || '');
    function t(pl, eng) { return en ? eng : pl; }
    var panel = doc.querySelector('[data-ra-panel]');
    if (!panel) return;
    var gra = panel.getAttribute('data-gra');
    var status = panel.querySelector('[data-ra-status]');
    function message(s) { if (status) status.textContent = s; }
    function observed() { return root.PewniakiObserwowane ? root.PewniakiObserwowane.lista(gra) : []; }
    function sync() {
        var lista = observed();
        panel.querySelectorAll('[data-ra-observe]').forEach(function (b) {
            if (!root.PewniakiObserwowane) return;
            b.hidden = false;
            var yes = lista.indexOf(Number(b.getAttribute('data-ra-observe'))) !== -1;
            b.setAttribute('aria-pressed', String(yes));
            b.textContent = yes ? jst("pages_rozbudowa_analiz_js.de452b7291e8") : jst("pages_rozbudowa_analiz_js.8fb1bbf86259");
        });
        panel.querySelectorAll('[data-ra-draft]').forEach(function (b) {
            if (!root.PewniakiSzkic) return;
            b.hidden = false;
            var yes = root.PewniakiSzkic.zawiera(gra, Number(b.getAttribute('data-ra-draft')), 'glowna');
            b.setAttribute('aria-pressed', String(yes));
            b.textContent = yes ? jst("pages_rozbudowa_analiz_js.ebfebfe674fb") : jst("pages_rozbudowa_analiz_js.af04596e7c3f");
        });
        panel.querySelectorAll('[data-ra-load-observed]').forEach(function (b) { b.hidden = !root.PewniakiObserwowane; });
    }
    panel.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !panel.contains(b)) return;
        var n, r;
        if (b.hasAttribute('data-ra-observe') && root.PewniakiObserwowane) {
            n = Number(b.getAttribute('data-ra-observe'));
            r = observed().indexOf(n) !== -1 ? root.PewniakiObserwowane.usun(gra, n) : root.PewniakiObserwowane.dodaj(gra, n);
            message(r && r.ok ? jst("pages_rozbudowa_analiz_js.0130b5816630") : jst("pages_rozbudowa_analiz_js.0fedfc086b15"));
            sync();
        } else if (b.hasAttribute('data-ra-draft') && root.PewniakiSzkic) {
            n = Number(b.getAttribute('data-ra-draft'));
            r = root.PewniakiSzkic.przelacz(gra, n, 'glowna');
            message(r && r.ok ? jst("pages_rozbudowa_analiz_js.bb3b30d528c5") : jst("pages_rozbudowa_analiz_js.b2bb80b37e37"));
            sync();
        } else if (b.hasAttribute('data-ra-load-observed')) {
            var input = panel.querySelector('[data-ra-numbers]');
            if (input) input.value = observed().join(', ');
            message(jst("pages_rozbudowa_analiz_js.2d8fef56b54e"));
        }
    });
    var companions = panel.querySelector('[data-ra-companions]');
    if (companions) {
        var boxes = Array.from(companions.querySelectorAll('[data-ra-companion]'));
        var count = companions.querySelector('[data-ra-selected]');
        function selected() { return boxes.filter(function (b) { return b.checked; }); }
        function updateCount() {
            count.textContent = jst("pages_rozbudowa_analiz_js.035a17888439") + selected().length + ' / 4';
        }
        companions.addEventListener('change', function (e) {
            if (!e.target.matches('[data-ra-companion]')) return;
            if (selected().length > 4) {
                e.target.checked = false;
                message(jst("pages_rozbudowa_analiz_js.a5f346963eab"));
            }
            updateCount();
        });
        var nearest = companions.querySelector('[data-ra-nearest]');
        nearest.hidden = false;
        nearest.addEventListener('click', function () {
            var ns = companions.getAttribute('data-domyslne').split(',').map(Number);
            boxes.forEach(function (b) { b.checked = ns.indexOf(Number(b.value)) !== -1; });
            updateCount();
            message(jst("pages_rozbudowa_analiz_js.9799fe923c24"));
        });
        updateCount();
    }
    var form = panel.querySelector('[data-ra-form]');
    if (form) {
        var length = form.querySelector('[data-ra-length]');
        if (length) length.addEventListener('change', function () {
            form.querySelector('[data-ra-pattern]').value = '';
        });
        form.addEventListener('submit', function (e) {
            if (companions && companions.querySelectorAll('[data-ra-companion]:checked').length > 4) {
                e.preventDefault(); message(jst("pages_rozbudowa_analiz_js.9da3b4e62441"));
            }
        });
    }
    var map = doc.querySelector('[data-ra-map]');
    if (map && root.PewniakiObserwowane) {
        var filter = map.querySelector('[data-ra-only-observed]');
        var mapMessage = map.querySelector('[data-ra-map-message]');
        filter.hidden = false;
        function filterMap() {
            var only = filter.getAttribute('aria-pressed') === 'true', ns = observed();
            map.querySelectorAll('[data-ra-column]').forEach(function (cell) {
                cell.hidden = only && ns.indexOf(Number(cell.getAttribute('data-ra-column'))) === -1;
            });
            mapMessage.textContent = only && !ns.length ? jst("pages_rozbudowa_analiz_js.5749dd224b6e") : '';
        }
        filter.addEventListener('click', function () {
            filter.setAttribute('aria-pressed', String(filter.getAttribute('aria-pressed') !== 'true'));
            filterMap();
        });
        doc.addEventListener('pewniaki:obserwowane-zmiana', filterMap);
    }
    doc.addEventListener('pewniaki:obserwowane-zmiana', sync);
    doc.addEventListener('pewniaki:szkic-zmiana', sync);
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', sync, { once: true });
    else sync();
})(window, document);
